import { render, staticRenderFns } from "./Formulaires.vue?vue&type=template&id=6a99b0f4"
import script from "./Formulaires.vue?vue&type=script&lang=js"
export * from "./Formulaires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports